import { useNavigate } from 'react-router-dom';
import DropdownListWithActions from '../../componentsv2/DropdownListWithActions';
import { AddIcon } from '../../components/Icons';
import { useAppSelector, setSelectedCompany } from '../../store';
import { useTranslation } from '../../hooks/i18n';
import { Company, CompanyUser } from '../../types/companyUser';
import { ACTIVATION } from '../../constants/auth';

interface MultiCompanySelectorProps {
  isCollapsed?: boolean;
  openDrawer: () => void;
}

const MultiCompanySelector = ({ isCollapsed, openDrawer }: MultiCompanySelectorProps) => {
  const { t } = useTranslation(['user', 'common']);
  const navigate = useNavigate();
  const { draftCompany, companies = [] } =
    useAppSelector((state) => state.companyUser.companyUser) || ({} as CompanyUser);
  const selectedCompany =
    useAppSelector((state) => state.companyUser.companyUser?.selectedCompany) || ({} as Company);
  const companyOptions = companies.map((company) => ({
    value: company.id,
    label: company.name,
  }));
  const actions = [
    {
      icon: <AddIcon />,
      label: t('user:multicompany.newcompany.title'),
      onClick: () => navigate(ACTIVATION, { state: { createNewDraft: true } }),
      disabled: draftCompany !== null || companies.length === 0,
    },
  ];

  const handleChangeSelectedCompany = (option: { value: number; label: string }) => {
    setSelectedCompany(option.value.toString());
  };

  return (
    <DropdownListWithActions
      options={companyOptions}
      currentOption={{ value: selectedCompany.id, label: selectedCompany.name }}
      setCurrentOption={(option) => handleChangeSelectedCompany(option)}
      actions={actions}
      isCollapsed={isCollapsed}
      openDrawer={openDrawer}
    />
  );
};

export default MultiCompanySelector;
